import { cn } from '@/lib/utils'
import AddTokenButton from '../AddTokenToWallet'
import { testIdFactory } from '@/utils/test-id-factory.ts'

export function AddPepperToken({ className }: { className?: string }) {
	return (
		<AddTokenButton
			className={cn('border-green-20 border-1 py-2 px-4 rounded-[60px] gap-2 text-neutral-100', className)}
			data-testid={testIdFactory.homeAddPepperButton()}
		>
			<img
				src="https://assets-staking.chiliz.com/images/assets/pepper.webp"
				alt="logo"
				className="w-[44px] aspect-square"
			/>
			<span className="text-neutral-100 text-[1.5rem] leading-6">Add PEPPER to wallet</span>
		</AddTokenButton>
	)
}
